<template>
  <button v-if="!link" :class="mode" :disabled="ckdisablde">
    <slot></slot>
  </button>
  <router-link v-else :to="to" :class="mode">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      required: false,
      default: null
    },
    link: {
      type: Boolean,
      required: false,
      default: false
    },
    to: {
      type: String,
      required: false,
      default: '/'
    },
    ckdisablde:{
      type: Boolean,
      required: false,
      default: false  
    }
  }
}
</script>

<style scoped>
button,
a {
  text-decoration: none;
  position: relative;
  transition: all .15s ease;
  letter-spacing: .025em;
  text-transform: none;  
  line-height: 1.5;
  padding: .25rem .5rem;
  border-radius: .25rem;
  font: inherit;
  border: 1px solid #172b4d;
  color: white;
  cursor: pointer;  
  display: inline-block;
  background-color:  #172b4d; 
  box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
  margin:0 5px;
  will-change: transform;
}

a:hover,
a:active,
button:hover,
button:active {    
  transform: translateY(-1px); 
  box-shadow: 0 7px 14px rgba(50, 50, 93, .1), 0 3px 6px rgba(0, 0, 0, .08);
}
.btn-white{
  background: -webkit-linear-gradient(to bottom, #fefdfd, #f8f8f7); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to bottom, #fefdfd, #f8f8f7); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  border-color:#d6d6d6;
  color:#bdbab9;
  box-shadow:none;
  font-weight:normal;
}
.btn-info {
  border-color: #11cdef;
  background-color: #11cdef;
}
.btn-primary {
  border-color: #5e72e4;
  background-color: #5e72e4;
}
.btn-danger {
  border-color: #ED213A;
  background-color: #ED213A;
}
.red{
  width:100%;
  border: 1px solid #b72e00;
  background-color: #c30;
  margin-bottom: 17px;
  font-weight:bold;
  padding: 1.2rem 1.5rem;
}
.red:hover{
  background:#b72e00;  
}
.red_sm{
  width:100%;
  border: 1px solid #b72e00;
  background-color: #c30;
  margin-bottom: 17px;
  font-weight:bold;
  padding: 0.5rem 1.5rem;
}
.red_sm:hover{
  background:#b72e00;  
}
.skyblue{
  width:100%;
  height:100%;
  background-color:#2a95bf;
  border: none;
}
.skyblue:hover{
  background-color:#2a86b5;
}

.orange{
  width:100%;
  height:100%;
  background-color:#f25116;
  border: none;
}
.orange:hover{
  background-color:#c84718;
}

.darkblue{
  width:100%;
  height:100%;
  background-color:#1a2f6a;
  border: none;
}
.darkblue:hover{
  background-color:#0c1031;
}

.darkred{
  width:100%;
  height:100%;
  background-color:#5f121b;
  border: none;
}
.darkred:hover{
  background-color:#310c1c;
}

.outline_gray{
  border: 2px solid #d1d1d1;
  width:100%;
  height:100%;
  background-color:#fff;
  color: #000;  
}
.outline_gray:hover{
  background-color:#d1d1d1;
}

.outline {
  background-color: #3a0061;
  border-radius: 30px;
  border-color: #270041;
  color: #270041;
}
.outline-red{
  padding: 14px 25px 13px;
  border: 1px solid #ed2026;
  background-color: #fff;
  color: #ed2026;
  font-size: 12px;
}
.outline-red:hover{
  background: #ed2026;
  color:#fff;
}
.flat:hover,
.flat:active,
.outline:hover,
.outline:active {
  background-color: #edd2ff;
}
button:focus { outline: none; }
.disable{
  border: 1px solid #d1d1d1; 
  background-color:#fff;
  color: #5c5c5c;  
   width:100%;
}
.disable:hover{
  border: 1px solid #d1d1d1; 
  background-color:#fff;
   color: #5c5c5c;  
}
</style>
